import { render } from "./inputitems.vue?vue&type=template&id=0413a92a"
import script from "./inputitems.vue?vue&type=script&lang=js"
export * from "./inputitems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__